import React from 'react'
import { Route } from 'react-router-dom'
import InvoiceTable from './InvoiceTable'
import Pagination from '../shared/Pagination'

/**
 * InvoiceRoute renders a tab's list view (InvoiceTable + Pagination).
 *
 * Detail pages (/path/:id) are NOT handled here: both containers match them in
 * their own top-level <Switch>, above the list chrome, so a detail page renders
 * without the header, the tabs and the search bar.
 */
export default function InvoiceRoute({
  path,
  columns,
  renderActions,
  invoices,
  onPageChange,
  currentPage,
  totalPages,
}) {
  /**
   * WHY render prop instead of JSX children:
   * In React Router v4/v5 (pre-5.1), <Route path="…"><JSX/></Route> passes
   * content via the `children` prop, which React Router ALWAYS renders
   * regardless of whether the path matches (it exists for animation use-cases).
   * The `render` prop is the one that gates on path match.
   */
  return (
    <Route
      exact
      path={path}
      render={() => (
        <>
          <InvoiceTable
            columns={columns}
            renderActions={renderActions}
            linking={path}
            invoices={invoices}
          />
          {/* `>` on a possibly-null totalPages, never `totalPages && …`: a 0
              total would otherwise be rendered as a literal "0" under an
              empty list. */}
          {totalPages > 1 && (
            <div className="invoice-layout-pagination">
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage + 1}
                onPageChange={onPageChange(path)}
              />
            </div>
          )}
        </>
      )}
    />
  )
}
